export const PUBLISH_POST_REQUEST = 'post/PUBLISH_REQUEST';
export const PUBLISH_POST_SUCCESS = 'post/PUBLISH_SUCCESS';
export const PUBLISH_POST_FAILURE = 'post/PUBLISH_FAILURE';
